import React from "react";

const OdulSistemi = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>TEMELDEN ÖDÜL SİSTEMİ</h1>
        
        <section style={styles.section}>
          <h2 style={styles.heading}>Platformumuz Hakkında</h2>
          <p style={styles.text}>
            Temelden, gayrimenkul sektöründe dijital dönüşümü liderlik eden, kullanıcılarına 
            en güncel ve güvenilir emlak hizmetlerini sunan bir platformdur. Kurumsal firmalar 
            ve bireysel kullanıcılar için tasarlanmış modern araçlarımız ile gayrimenkul 
            yatırımlarınızı kolaylaştırıyor, süreçleri şeffaf ve verimli hale getiriyoruz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Yeni Ödül Sistemi Geliyor!</h2>
          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>Mobil Uygulama Özel Ödüller</h3>
            <p style={styles.featureText}>
              Yakında gelecek olan yeni güncelleme ile birlikte, mobil uygulamamız üzerinden 
              platforma üye olan kullanıcılarımız için özel bir ödül sistemi başlatıyoruz. 
              Bu sistem ile hem platformu daha yakından tanıyacak hem de değerli hediyeler 
              kazanma şansı elde edeceksiniz.
            </p>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Ödül Sisteminden Nasıl Yararlanabilirsiniz?</h2>
          <div style={styles.stepsContainer}>
            <div style={styles.step}>
              <div style={styles.stepNumber}>1</div>
              <div style={styles.stepContent}>
                <h4 style={styles.stepTitle}>Mobil Uygulamayı İndirin</h4>
                <p style={styles.stepText}>
                  App Store veya Google Play Store'dan Temelden mobil uygulamasını ücretsiz indirin
                </p>
              </div>
            </div>

            <div style={styles.step}>
              <div style={styles.stepNumber}>2</div>
              <div style={styles.stepContent}>
                <h4 style={styles.stepTitle}>Üye Olun</h4>
                <p style={styles.stepText}>
                  Mobil uygulama üzerinden kolayca üyelik işleminizi tamamlayın
                </p>
              </div>
            </div>

            <div style={styles.step}>
              <div style={styles.stepNumber}>3</div>
              <div style={styles.stepContent}>
                <h4 style={styles.stepTitle}>Ödülleri Kazanın</h4>
                <p style={styles.stepText}>
                  Ödül sistemimiz aktif olduğunda anında haberdar olun ve kazanmaya başlayın
                </p>
              </div>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Ödül Kategorileri</h2>
          <div style={styles.rewardsGrid}>
            <div style={styles.rewardCard}>
              <h4 style={styles.rewardTitle}>İndirim Oranları</h4>
              <p style={styles.rewardText}>
                %1'den %10'a kadar özel indirim fırsatları
              </p>
            </div>

            <div style={styles.rewardCard}>
              <h4 style={styles.rewardTitle}>Mobil Uygulama Üyeliği</h4>
              <p style={styles.rewardText}>
                Mobil uygulamamıza üye olarak ödüllerden yararlanabilir, çekilişlere katılabilirsiniz.
              </p>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Önemli Bilgiler</h2>
          <div style={styles.infoBox}>
            <ul style={styles.infoList}>
              <li style={styles.infoItem}>
                Ödül sistemi sadece mobil uygulama üzerinden üye olan kullanıcılarımıza özeldir
              </li>
              <li style={styles.infoItem}>
                Sistem yakında aktif edilecek olup, duyurular mobil uygulama üzerinden yapılacaktır
              </li>
              <li style={styles.infoItem}>
                Tüm ödül kazanımları şirketimizin belirlediği koşullara tabidir
              </li>
              <li style={styles.infoItem}>
                Ödül sistemi KVKK ve ilgili mevzuatlara uygun şekilde tasarlanmıştır
              </li>
            </ul>
          </div>
        </section>

        <section style={styles.ctaSection}>
          <h2 style={styles.ctaTitle}>Hazır mısınız?</h2>
          <p style={styles.ctaText}>
            Ödül sisteminden yararlanmak için hemen mobil uygulamayı indirin ve 
            platformumuza katılın. Fırsatları kaçırmayın!
          </p>
          <div style={styles.ctaButtons}>
            <button 
              style={styles.ctaButton}
              onClick={() => window.location.href = "https://play.google.com/store/apps/details?id=com.vondijital.temelden_app&hl=tr"}
            >
              Google Play'den İndir
            </button>
            <button 
              style={styles.ctaButton}
              onClick={() => window.location.href = "https://apps.apple.com/tr/app/temelden/id6758143279?l=tr"}
            >
              App Store'dan İndir
            </button>
          </div>
        </section>

        <section style={styles.contactSection}>
          <p style={styles.contactText}>
            Sorularınız için:{" "}
            <a href="mailto:info@vondigital.com.tr" style={styles.contactLink}>
              info@vondigital.com.tr
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "35px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "15px",
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
    lineHeight: "1.6",
  },
  featureCard: {
    backgroundColor: "#f8f9fa",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  },
  featureTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#001E78",
    marginBottom: "10px",
  },
  featureText: {
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.6",
  },
  stepsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  step: {
    display: "flex",
    alignItems: "flex-start",
    gap: "15px",
  },
  stepNumber: {
    backgroundColor: "#001E78",
    color: "white",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "600",
    flexShrink: 0,
  },
  stepContent: {
    flex: 1,
  },
  stepTitle: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "5px",
  },
  stepText: {
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.5",
  },
  rewardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    marginTop: "15px",
  },
  rewardCard: {
    backgroundColor: "#f8f9fa",
    padding: "15px",
    borderRadius: "6px",
    border: "1px solid #e9ecef",
    textAlign: "center",
  },
  rewardTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#001E78",
    marginBottom: "8px",
  },
  rewardText: {
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.4",
  },
  infoBox: {
    backgroundColor: "#fff8e1",
    padding: "20px",
    borderRadius: "6px",
    border: "1px solid #ffd54f",
  },
  infoList: {
    paddingLeft: "20px",
    margin: 0,
  },
  infoItem: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "8px",
    lineHeight: "1.5",
  },
  ctaSection: {
    backgroundColor: "#001E78",
    padding: "30px",
    borderRadius: "8px",
    textAlign: "center",
    marginBottom: "25px",
  },
  ctaTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "white",
    marginBottom: "10px",
  },
  ctaText: {
    fontSize: "14px",
    color: "white",
    marginBottom: "20px",
    lineHeight: "1.6",
  },
  ctaButtons: {
    display: "flex",
    gap: "15px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  ctaButton: {
    backgroundColor: "white",
    color: "#001E78",
    padding: "12px 20px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    minWidth: "160px",
  },
  contactSection: {
    textAlign: "center",
    paddingTop: "20px",
    borderTop: "1px solid #f0f0f0",
  },
  contactText: {
    fontSize: "14px",
    color: "#555",
  },
  contactLink: {
    color: "#001E78",
    textDecoration: "none",
  },
};

// Hover efektleri
styles.ctaButton = {
  ...styles.ctaButton,
  ":hover": {
    backgroundColor: "#f8f9fa",
  },
};

styles.contactLink = {
  ...styles.contactLink,
  ":hover": {
    textDecoration: "underline",
  },
};

export default OdulSistemi;